import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Admin_Employees_List, Admin_Region_Assignment, Admin_Region_Name } from '../../../../constants';
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';

const defaultForm = {
  EmployeeId: '',
  RegionId: '',
  Project: 'Parivartan',
  is_bdm: false,
  is_zonal_manager: false,
};

const AssignRegionModal = ({
  isOpen,
  onClose,
  onAssigned,
}) => {
  const [employees, setEmployees] = useState([]);
  const [regions, setRegions] = useState([]);
  const [form, setForm] = useState({ ...defaultForm });

  useEffect(() => {
    if (!isOpen) return;
    const fetchOptions = async () => {
      try {
        const [empRes, regRes] = await Promise.all([
          axios.get(`${Admin_Employees_List}`),
          axios.get(`${Admin_Region_Name}`),
        ]);
        if (empRes.data.success) setEmployees(empRes.data.data);
        if (regRes.data.success) setRegions(regRes.data.data);
      } catch {
        toast.error('Failed to load employees or regions');
      }
    };
    fetchOptions();
    setForm({ ...defaultForm }); // Reset form when modal opens
  }, [isOpen]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    console.log("handleSubmit called with form:", form);
    
    
    const selectedEmp = employees.find(
      (e) => (e.EmployeeId) === (form.EmployeeId)
    );
    console.log('selectedEmp', selectedEmp);
    
    if (!selectedEmp) return toast.error('Please select a valid employee');
    if (!form.RegionId) return toast.error('Please select a region');
    const payload = {
      EmployeeId: form.EmployeeId,
      EmployeeName: selectedEmp.EmployeeName,
      RegionId: form.RegionId,
      Project: form.Project,
      is_bdm: form.is_bdm ? 'Yes' : 'No',
      is_zonal_manager: form.is_zonal_manager ? 'Yes' : 'No',
    };
    console.log('Submitting:', payload);
    try {
      const res = await axios.post(
      Admin_Region_Assignment,
        payload
      );
      console.log('Response:', res);

      if (res.data.success) {
        toast.success('Region assigned');
        onAssigned();
        onClose();
      } else {
        toast.error(res.data.message || 'Failed to assign region');
      }
    } catch (err) {
      const message =
        err?.response?.data?.message || err?.message || 'Something went wrong';
      toast.error(message);
    }
  };

  if (!isOpen) return null;

  return (
    // <div className="modal modal-open">
    //   <div className="modal-box max-w-sm">
    //     <h3 className="font-bold text-lg mb-4">Assign New Region</h3>
    //     <div className="mb-4 space-y-2">
    //       {/* Employee */}
    //       <label className="block text-sm font-medium mb-1">Employee</label>
    //       <select
    //         className="select select-bordered w-full"
    //         value={form.EmployeeId}
    //         onChange={(e) => handleChange('EmployeeId', e.target.value)}
    //       >
    //         <option value="">Select Employee</option>
    //         {employees
    //           .filter((emp) => [1, 2, 3].includes(emp.EmployeeRoleID))
    //           .map((emp) => (
    //             <option key={emp.EmployeeId} value={emp.EmployeeId}>
    //               {emp.EmployeeName} ({emp.EmployeeId})
    //             </option>
    //           ))}
    //       </select>

    //       {/* Region */}
    //       <label className="block text-sm font-medium mb-1">Region</label>
    //       <select
    //         className="select select-bordered w-full"
    //         value={form.RegionId}
    //         onChange={(e) => handleChange('RegionId', e.target.value)}
    //       >
    //         <option value="">Select Region</option>
    //         {regions.map((region) => (
    //           <option key={region.RegionId} value={region.RegionId}>
    //             {region.RegionName}
    //           </option>
    //         ))}
    //       </select>

    //       {/* Project */}
    //       <label className="block text-sm font-medium mb-1">Project</label>
    //       <select
    //         className="select select-bordered w-full"
    //         value={form.Project}
    //         onChange={(e) => handleChange('Project', e.target.value)}
    //       >
    //         <option value="Parivartan">Parivartan</option>
    //         <option value="Gen Nxt">Gen Nxt</option>
    //         <option value="Open Shed">Open Shed</option>
    //       </select>

    //       {/* Roles */}
    //       <label className="block text-sm font-medium mb-1">Roles</label>
    //       <div className="flex gap-4">
    //         <label className="flex items-center gap-2">
    //           <input
    //             type="checkbox"
    //             checked={form.is_bdm}
    //             onChange={(e) => handleChange('is_bdm', e.target.checked)}
    //           />
    //           <span>BDM</span>
    //         </label>
    //         <label className="flex items-center gap-2">
    //           <input
    //             type="checkbox"
    //             checked={form.is_zonal_manager}
    //             onChange={(e) => handleChange('is_zonal_manager', e.target.checked)}
    //           />
    //           <span>Zonal Manager</span>
    //         </label>
    //       </div>
    //     </div>

    //     {/* Action Buttons */}
    //     <div className="modal-action">
    //       <button
    //         className="btn btn-ghost"
    //         onClick={onClose}
    //       >
    //         Cancel
    //       </button>
    //       <button
    //         className="btn btn-primary"
    //         onClick={handleSubmit}
    //       >
    //         Assign
    //       </button>
    //     </div>
    //   </div>
    // </div>
     <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Typography variant="h6"  fontWeight="bold">
          Assign New Region
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          {/* Employee */}
          <FormControl fullWidth>
            <InputLabel id="employee-label">Employee</InputLabel>
            <Select
              labelId="employee-label"
              label="Employee"
              value={form.EmployeeId}
              onChange={(e) => handleChange('EmployeeId', e.target.value)}
            >
              <MenuItem value="">
                <em>Select Employee</em>
              </MenuItem>
              {employees
                .filter((emp) => [1, 2, 3].includes(emp.EmployeeRoleID))
                .map((emp) => (
                  <MenuItem key={emp.EmployeeId} value={emp.EmployeeId}>
                    {emp.EmployeeName} ({emp.EmployeeId})
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          {/* Region */}
          <FormControl fullWidth>
            <InputLabel id="region-label">Region</InputLabel>
            <Select
              labelId="region-label"
              label="Region"
              value={form.RegionId}
              onChange={(e) => handleChange('RegionId', e.target.value)}
            >
              <MenuItem value="">
                <em>Select Region</em>
              </MenuItem>
              {regions.map((region) => (
                <MenuItem key={region.RegionId} value={region.RegionId}>
                  {region.RegionName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Project */}
          <FormControl fullWidth>
            <InputLabel id="project-label">Project</InputLabel>
            <Select
              labelId="project-label"
              label="Project"
              value={form.Project}
              onChange={(e) => handleChange('Project', e.target.value)}
            >
              <MenuItem value="Parivartan">Parivartan</MenuItem>
              <MenuItem value="Gen Nxt">Gen Nxt</MenuItem>
              <MenuItem value="Open Shed">Open Shed</MenuItem>
            </Select>
          </FormControl>

          {/* Roles */}
          <Box>
            <Typography variant="subtitle2" mb={1}>
              Roles
            </Typography>
            <Stack direction="row" spacing={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={form.is_bdm}
                    onChange={(e) => handleChange('is_bdm', e.target.checked)}
                  />
                }
                label="BDM"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={form.is_zonal_manager}
                    onChange={(e) => handleChange('is_zonal_manager', e.target.checked)}
                  />
                }
                label="Zonal Manager"
              />
            </Stack>
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSubmit}>
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignRegionModal;
